import { lt } from "../../../../date-fns/locale/lt.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    lt
  }
};